<template>
  <div class="stepThreeRoot">
    <div class="circleItem"><CircleVue currentIndex="3"></CircleVue> </div>
    <div class="backPageItem"><BackPageVue  @backPreviewPage="hanldGoBack"></BackPageVue> </div>

    <div class="titleBox">
      <div class="titleLine">When Will I Start Seeing Results?</div>
      <div class="subTitle">From submission to citation, academic visibility takes time.</div>
      <div class="subTitle">On average, expect to see early signs of visibility within <strong>0–2 months,</strong> and measurable citation growth within <strong>6–48 months.</strong></div>
    </div>

    <div class="echartBox">
      <div class="echartLeft">
        <div class="echartTitle">Typical Timeline for Research Impact</div>
        <!-- <div class="echartTitle">Normal Distribution</div> -->
        <div class="nameBlock" > 
            <div class="dotItem"></div>
            <div class="nameItem">Early feedback</div>
            <div class="dotItem" style="background: rgba(76, 175, 80, 1);margin-left: 20px;"></div>
            <div class="nameItem">Citation Accumulation Period</div>
        </div>
        <div class="nameBlock" style="margin:0"><div class="nameItem">Probability Density</div></div>
        <div ref="chart" class="echartItem" ></div>
      </div>
      <div class="echartRight">
          <div class="monthItem">0-2</div>
          <div class="textItem">Early signs of visibility and engagement</div>
          <div class="textCenter">During this period, you can track your paper’s early impact through journal view, download counts, email outreach responses, or third-party tools like Altmetric, PlumX, and ImpactStory.</div>
          <div class="monthItem" style="margin-top: 20px;">6-48</div>
          <div class="textItem">Measurable citation growth typically begins</div>
      </div>
    </div>
    <div class="btnLine">
        <!-- <div class="disBtn" v-if="chooseRadio==-1">Next step</div> -->
        <div class="chooseBtn"  @click="goToNextStep">Next</div>
    </div>
    <div class="LastLine">
          <div class="oneItem">©  2012-2026 PaperSpotlight. All rights reserved.</div>
          <div class="twoItem">The data presented is based on our independent research and analysis. While we strive for accuracy, results may vary across different fields and contexts. Unauthorized reproduction or distribution of this content is prohibited.</div>
    </div>
  </div>
</template>
<script>
import CircleVue from './circle.vue'
import BackPageVue from './backPage.vue'

export default {
    components:{CircleVue,BackPageVue},
  data(){
    return{
      imgObj:{
        guideHomebg1:require("../../assets/img/main/guideHomebg1.png"),
        guideHomebg2:require("../../assets/img/main/guideHomebg2.png"),
      },
      chartInstance: null


    }
},
mounted() {
  this.initChart();
},
beforeDestroy() {
  if (this.chartInstance) {
    this.chartInstance.dispose();
  }
},
methods:{
  hanldGoBack(){
      localStorage.setItem('guideIndex', 2);
      this.$emit('changePage', 2);
    },
  goToNextStep(){
          console.log(2223)
          localStorage.setItem('guideIndex', 4);
          this.$emit('changePage', 4);
      },
  initChart() {
      this.chartInstance = this.$echarts.init(this.$refs.chart);
      this.updateChart();
    },
    updateChart() {
      if (!this.chartInstance) return;
  
      const option = {
        grid: {
          left: '3%',
          right: '15%',
          bottom: '3%',
          top: '8%',
          containLabel: true,
          show: true,
          // borderColor: '#eee',
          // backgroundColor: '#fff'
        },
xAxis: {
  name: 'Months', // X轴名称
   nameTextStyle: {
    align: 'left', // 文字对齐方式
    padding: [0, 0, 0, -6], // 左内边距调整位置 [上,右,下,左]
    // 其他文本样式
  },
  type: 'category',
  boundaryGap: false
},
yAxis: {
  // name: 'Probability Density', // Y轴名称
  type: 'value',
  boundaryGap: [0, '30%'],
  // splitLine: {
  //         lineStyle: {
  //           type: 'dashed' // y轴网格线设置为虚线
  //         }
  //       }
},
visualMap: {
  type: 'piecewise',
  show: false,
  dimension: 0,
  seriesIndex: 0,
  pieces: [
    {
      gt: 0,
      lt: 1,
       color: 'rgba(76, 175, 80, 0.4)'
    },
    {
      gt: 3,
      lt: 24,
       color: 'rgba(76, 175, 80, 1)'
    }
  ]
},
series: [
  {
    type: 'line',
    smooth: 0.6,
    symbol: 'none',
    lineStyle: {
      color: '#FEAE00',
      width: 2
    },
    markLine: {
      symbol: ['none', 'none'],
      label: { show: false },
      data: [
            { xAxis: 0 ,lineStyle: {
              color: 'rgba(76, 175, 80, 0.4)',
              width: 1,
              type: 'dashed'
            }}, 
            { xAxis: 1,
              lineStyle: {
              color: 'rgba(76, 175, 80, 0.4)',
              width: 1,
              type: 'dashed'
            }
             }, 
             { xAxis: 3 ,
              lineStyle: {
              color: 'rgba(76, 175, 80, 1)',
              width: 1,
              type: 'dashed'
            }
             }, 
             { xAxis: 24,lineStyle: {
              color: 'rgba(76, 175, 80, 1)',
              width: 1,
              type: 'dashed'
            } }]
    },
      areaStyle: {
        opacity: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, opacity: 0 },
          { offset: 1, opacity: 0.1 }
        ])
      },
    data: [
       ['0', 0.0069],      // 起点
          ['2', 0.0116],     // 开始上升
          ['4', 0.0254],     // 加速上升
          ['6', 0.0432],     // 继续上升
          ['8', 0.0609],     // 接近峰值
          ['10', 0.0733],    // 接近峰值
          ['12', 0.0838],    // 即将达到峰值
          ['14', 0.0947],    // 峰值在14个月（0.135）
          ['16', 0.1125],    // 缓慢下降开始
          ['18', 0.1241],    // 非常平缓的下降
          ['20', 0.1273],    // 平缓下降
          ['22', 0.13],    // 继续平缓下降
          ['24', 0.1308],    // 24个月时仍然较高（参考图片红色线条）
          ['26', 0.1308],    // 缓慢下降
          ['28', 0.1308],    // 缓慢下降
          ['30', 0.1308],    // 平缓下降
          ['32', 0.1313],     // 平缓下降
          ['34', 0.1313],    // 平缓下降
          ['36', 0.1302],     // 36个月时约0.10
          ['38', 0.1259],    // 平缓下降
          ['40', 0.1157],     // 40个月时约0.09
          ['42', 0.1063],    // 平缓下降
          ['44', 0.099],     // 平缓下降
          ['46', 0.09],    // 平缓下降
          ['48', 0.0776]      // 终点，仍然保持相对较高水平
    ]
  },
  
]
};

if (option && typeof option === 'object') {
this.chartInstance.setOption(option, true);

  }


      // 响应式调整
      window.addEventListener('resize', this.handleResize);
    },
}
}
</script>

<style lang="scss">
.stepThreeRoot{
  width: 100%;
  // height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding: 60px 0 30px 0;
  gap: 50px;
  position: relative;
    .backPageItem{
      position: absolute;
      left: 100px;
      top:40px;
      width: 30px;
      height: 30px;
    }
    .circleItem{
      position: absolute;
      right: 100px;
      top:40px;
      width: 50px;
      height: 50px;
    }
  .titleBox{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .titleLine{
    max-width: 900px;
    color: #000;
    text-align: center;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
  }
  .subTitle{
    width: 80%;
    max-width: 1000px;
      margin-top: 10px;
      color: var(---2, #333);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-transform: capitalize;
  }
  .echartBox{
    width: 100%;
    // max-width: 1200px;
    display: flex;
    justify-content: center;
    gap: 30px;
    flex: 1 1;
    align-items: center;
    .echartItem{
      width: 550px; 
      height:300px;
    }
    .echartLeft{
      text-align: left;
      .echartTitle{
        color: var(---2, #000);
        font-size: 18px;
        font-weight: 700;
        font-style: normal;
        line-height: 22px; /* 110% */
      }
      .nameBlock{
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 12px 0 6px 0;
        .dotItem{
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background:rgba(76, 175, 80, 0.4);// rgba(76, 175, 80, 1);
        }
        .nameItem{
          color: var(---2, #333);
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
    .echartRight{
      width: 550px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .monthItem{
        color: var(--Color-, #FEAE00);
        font-size: 60px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
      .textItem{
        color: #999;
        // text-align: center;
        font-style: italic; 
        /* 按钮字体 */
        font-size: 16px;
        font-weight: 400;
        line-height: normal;
      }
      .textCenter{
        color: #333;
        font-size: 16px;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
  .btnLine{
        display: flex;
      justify-content: center;
      align-items: center;
      .disBtn{
          display: inline-block;
          background: #E0E0E0;
          color: #fff;
          padding: 12px 40px;
          border-radius: 8px;
          font-size: 16px;
      }
      .chooseBtn{
          cursor: pointer;
          display: inline-block;
          background: #212121;
          color: #fafafa;
          padding: 12px 40px;
          border-radius: 8px;
          font-size: 16px;
      }
      .chooseBtn:hover{
          background: #424242;
      }
      .chooseBtn:active{
          background: #212121;
      }
      

  }
  .LastLine{
    display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 6px;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
  }
}
@media screen and (max-width:767px) { 
  .stepThreeRoot{
  width: 100%;
  // height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20vw 6vw 10vw 6vw;
  gap: 6vw;
  position: relative;
  .backPageItem{
      position: absolute;
      left: 2vw;
      top:3vw;
      width: 4vw;
      height: 4vw;
    }
  .circleItem{
      position: absolute;
      right: 2vw;
      top:3vw;
      width: 8vw;
      height: 8vw;
    }
  .titleBox{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .titleLine{
    max-width: 900px;
    color: #000;
    text-align: center;
    font-size: 6vw;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
  }
  .subTitle{
    width: 100%;
    max-width: 600px;
      margin-top: 2vw;
      color: var(---2, #333);
      text-align: center;
      font-size: 3.4vw;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-transform: capitalize;
  }
  .echartBox{
    // max-width: 1200px;
    display: flex;
    flex-direction: column;
    gap: 5vw;
    justify-content: center;
    align-items: start;
    .echartItem{
      width: 100%; 
      height:60vw;
    }
    .echartLeft{
      width: 100%;
      .echartTitle{
        color: var(---2, #333);
        font-size: 3.2vw;
        font-style: normal;
        line-height: 1.3; /* 110% */
      }
      .nameBlock{
        display: flex;
        align-items: center;
        gap: 1.6vw;
        margin: 2vw 0 1vw 0;
        .dotItem{
          width: 2vw;
          height: 2vw;
          border-radius: 50%;
          background: rgba(76, 175, 80, 0.4);;
        }
        .nameItem{
          color: var(---2, #333);
          font-size: 3vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
    .echartRight{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .monthItem{
        color: var(--Color-, #FEAE00);
        font-size: 8vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
      .textItem{
        color: #999;
        // text-align: center;

        /* 按钮字体 */
        font-size: 3.4vw;
        font-weight: 400;
        line-height: normal;
      }
      .textCenter{
        color: #333;
        font-size: 3.4vw;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
  .btnLine{
        display: flex;
      justify-content: center;
      align-items: center;
      .disBtn{
          display: inline-block;
          background: #E0E0E0;
          color: #fff;
          padding: 1.2vw 4vw;
          border-radius: 8px;
          font-size: 3.4vw;
      }
      .chooseBtn{
          cursor: pointer;
          display: inline-block;
          background: #212121;
          color: #fafafa;
          padding: 1.2vw 4vw;
          border-radius: 8px;
          font-size: 3.4vw;
      }
      .chooseBtn:hover{
          background: #424242;
      }
      .chooseBtn:active{
          background: #212121;
      }
      

  }
  .LastLine{
    display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          gap: 1vw;
          .oneItem{
            color: var(---1, #000);
            text-align: center;
            font-size: 3.4vw;
            font-style: normal;
            font-weight: 400;
            line-height: 1.3; /* 110% */
          }
          .twoItem{
            width: 90%;
            max-width: 900px;
            color: #aaa;
            text-align: center;
            font-size: 3vw;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
  }
}
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
.stepThreeRoot{
  width: 100%;
  // height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  padding: 6vw 0 3vw 0;
  gap: 5vw;
  position: relative;
  .backPageItem{
      position: absolute;
      left: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
  .circleItem{
      position: absolute;
      right: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
  .titleBox{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .titleLine{
    max-width: 800px;
    color: #000;
    text-align: center;
    font-size: 3.2vw;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
  }
  .subTitle{
      margin-top: 10px;
      color: var(---2, #333);
      text-align: center;
      font-size: 1.6vw;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-transform: capitalize;
  }
  .echartBox{
    // width: 90%;
    display: flex;
    gap: 4vw;
    justify-content: center;
   
    .echartItem{
      width: 45vw; 
      height:26vw;
    }
    .echartLeft{
      .echartTitle{
        color: var(---2, #333);
        font-size: 1.8vw;
        font-style: normal;
        line-height: 1.3; /* 110% */
      }
      .nameBlock{
        display: flex;
        align-items: center;
        gap: 0.8vw;
        margin: 1.2vw 0 0.6vw 0;
        .dotItem{
          width: 1vw;
          height: 1vw;
          border-radius: 50%;
          background: rgba(76, 175, 80, 0.4);;
        }
        .nameItem{
          color: var(---2, #333);
          font-size: 1.2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
    .echartRight{
      width: 45vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .monthItem{
        color: var(--Color-, #FEAE00);
        font-size: 6vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
      .textItem{
        color: #999;
        // text-align: center;

        /* 按钮字体 */
        font-size: 1.6vw;
        font-weight: 400;
        line-height: normal;
      }
      .textCenter{
        color: #333;
        font-size: 1.6vw;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
  .btnLine{
        display: flex;
      justify-content: center;
      align-items: center;
      .disBtn{
          display: inline-block;
          background: #E0E0E0;
          color: #fff;
          padding: 1.2vw 4vw;
          border-radius: 8px;
          font-size: 1.6vw;
      }
      .chooseBtn{
          cursor: pointer;
          display: inline-block;
          background: #212121;
          color: #fafafa;
          padding: 1.2vw 4vw;
          border-radius: 8px;
          font-size: 1.6vw;
      }
      .chooseBtn:hover{
          background: #424242;
      }
      .chooseBtn:active{
          background: #212121;
      }
      

  }
  .LastLine{
    display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 0.6vw;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 1.6vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.3; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;

          text-align: center;
          font-size: 1.2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
  }
}
}
</style>